import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { useSystemTheme } from "context/SystemThemeContext";

const NightShiftBadge = ({ isNightShift, timeRange, size = 'small' }) => {
  const { mode } = useSystemTheme();
  const isDarkMode = mode === "dark";
  
  if (!isNightShift) return null;
  
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Chip
        label={size === 'small' ? "🌙 Night" : "🌙 Night Shift"}
        size={size}
        sx={{
          fontSize: size === 'small' ? '0.65rem' : '0.75rem',
          height: size === 'small' ? '18px' : '24px',
          backgroundColor: '#4527a0',
          color: '#fff',
          '& .MuiChip-label': {
            padding: size === 'small' ? '0 6px' : '0 8px',
          }
        }}
      />
      {timeRange && (
        <Tooltip title={`Night shift hours: ${timeRange}`}>
          <InfoOutlined 
            fontSize="small" 
            sx={{ 
              color: isDarkMode ? '#a0aec0' : '#666', 
              fontSize: '0.8rem',
              transition: 'color 0.3s ease',
            }} 
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default NightShiftBadge;